var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReadIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2542_37300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.28906 0.882652H2.95573C2.77892 0.882652 2.60935 0.95289 2.48432 1.07791C2.3593 1.20294 2.28906 1.37251 2.28906 1.54932V6.88265C2.28906 7.05946 2.3593 7.22903 2.48432 7.35406C2.60935 7.47908 2.77892 7.54932 2.95573 7.54932H6.95573C7.13254 7.54932 7.30211 7.47908 7.42713 7.35406C7.55216 7.22903 7.6224 7.05946 7.6224 6.88265V3.21599L5.28906 0.882652Z",
    stroke: "#343B53",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28906 0.882652V3.21599H7.6224",
    stroke: "#343B53",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2542_37300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(0.955078 0.215988)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadIc);
export default __webpack_public_path__ + "static/media/read-ic.8b3da8de11897255ff8bec549db45448.svg";
export { ForwardRef as ReactComponent };